var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4050_3825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8042 0C11.5757 0 0 11.5757 0 25.8042C0 40.0326 11.5757 51.6083 25.8042 51.6083C40.0326 51.6083 51.6083 40.0326 51.6083 25.8042C51.6083 11.5757 40.0326 0 25.8042 0ZM25.8042 48.3828C13.3543 48.3828 3.22552 38.2541 3.22552 25.8042C3.22552 13.3543 13.3543 3.22552 25.8042 3.22552C38.2541 3.22552 48.3828 13.3543 48.3828 25.8042C48.3828 38.2541 38.2541 48.3828 25.8042 48.3828ZM37.6983 25.8042C37.6983 26.2319 37.5284 26.6421 37.2259 26.9446C36.9235 27.247 36.5132 27.4169 36.0855 27.4169H27.4169V36.0855C27.4169 36.5132 27.247 36.9235 26.9446 37.2259C26.6421 37.5284 26.2319 37.6983 25.8042 37.6983C25.3764 37.6983 24.9662 37.5284 24.6638 37.2259C24.3613 36.9235 24.1914 36.5132 24.1914 36.0855V27.4169H15.5228C15.0951 27.4169 14.6849 27.247 14.3824 26.9446C14.08 26.6421 13.9101 26.2319 13.9101 25.8042C13.9101 25.3764 14.08 24.9662 14.3824 24.6638C14.6849 24.3613 15.0951 24.1914 15.5228 24.1914H24.1914V15.5228C24.1914 15.0951 24.3613 14.6849 24.6638 14.3824C24.9662 14.08 25.3764 13.9101 25.8042 13.9101C26.2319 13.9101 26.6421 14.08 26.9446 14.3824C27.247 14.6849 27.4169 15.0951 27.4169 15.5228V24.1914H36.0855C36.5132 24.1914 36.9235 24.3613 37.2259 24.6638C37.5284 24.9662 37.6983 25.3764 37.6983 25.8042Z",
    fill: "#662D91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4050_3825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.6083,
    height: 51.6083,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBrowser);
export default __webpack_public_path__ + "static/media/plus_browser.fad560545dc91270b26d61559c8f25d3.svg";
export { ForwardRef as ReactComponent };